/*
  Submits the sort form on change and hides its submit button. The button is in
  the markup so sorting still works with JS off or before this file parses —
  hiding it here rather than in CSS means it is never hidden from someone who
  still needs it.
*/
class CurbiSort extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    const select = this.querySelector('select');
    const submit = this.querySelector('[type="submit"]');
    if (!form || !select) return;

    if (submit) submit.hidden = true;
    select.addEventListener('change', () => form.submit());
  }
}

customElements.define('curbi-sort', CurbiSort);
